module.exports = __webpack_public_path__ + "img/rukavy_81_modra.7888e3b1.png";